<app-option-bar [type]="'MASTERSUITE'" [details]="mastersuiteDetails"></app-option-bar>
<div class="endpoint-wrapper">
  <div class="container-fluid">
    <div class="content-wrapper">
      <!-- Menu Section -->
      <div class="inner-nav">
        <app-left-menu [details]="mastersuiteDetails" [type]="'MASTERSUITE'"></app-left-menu>
      </div>
      <!-- Main content area  -->
      <div class="inner-content collapsed">
        <div class="common-section">
          <div class="common-heading">
            <span class="truncate-text" [title]="mastersuiteDetails.name">{{ mastersuiteDetails.name }}</span>
            <a class="float-right" style="font-size: 12px; color: #0288d1" (click)="showEnvMapperDetails()">
              <i>Environment Mapper Details</i>
            </a>
          </div>
          <div class="common-box">
            <div class="details-section">
              <div class="row">
                <div class="col-12" *ngIf="mastersuiteDetails.description">
                  <label>Description :</label>
                  {{ mastersuiteDetails.description }}
                </div>

                <div class="col-6">
                  <label>Project :</label>
                  <a [routerLink]="['/user/projects']" [queryParams]="{ id: mastersuiteDetails.project.id, default: false }"
                    target="_blank">&nbsp;{{ mastersuiteDetails.project.name }}</a>
                </div>

                <div class="col-6" *ngIf="mastersuiteDetails.environmentMap">
                  <label>Environment map :</label>
                  {{ mastersuiteDetails.environmentMap.name }}
                </div>

                <div class="col-6">
                  <label>Parallel Run :</label>
                  {{ mastersuiteDetails.parallelRun }}
                </div>

                <div class="col-6">
                  <label class="font-bold">Created on :</label>
                  {{ mastersuiteDetails.createdOn | localDate}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="testcase-endpoint-sec">
          <div class="row">
            <div class="col-6">
              <div class="common-section">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="common-heading heading-button ">List of TestSuites</div>
                  <a [routerLink]='"/testsuite/new"' target="_blank"><button class="btn btn-sm ml-2 text-white" style="background-color: #0288d1;" ngbTooltip="Create testsuite">Create</button></a>
                </div>
                <div class="common-box">
                  <div class="testcase-list">
                    <div *ngIf="!testSuiteList || testSuiteList.length === 0">No data found</div>
                    <div *ngFor="let testSuite of testSuiteList; let index = index" class="list" title="{{ testSuite.testSuiteName }}"
                      [ngClass]="{ active: activeId === testSuite.testSuiteId }"
                      (click)="getTestcasesByTestSuiteId(testSuite.testSuiteId)">
                      <a [routerLink]="['/testsuite', testSuite.testSuiteId]" target="_blank">
                        <i class="fas fa-link" ngbTooltip="Go to testsuite"></i>
                      </a>
                      {{index + 1}}. {{ testSuite.testSuiteName }}
                      <span class="float-right">
                        <i [ngClass]="{ 'text-danger': !testSuite.active }" class="fas fa-ban mr-1"
                          [title]="!testSuite.active ? 'Disable' : 'Enable'"></i></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-sm-6 col-xs-12">
              <div class="common-section">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="common-heading heading-button ">List of Testcases</div>
                  <a [routerLink]='"/testcase/new"' target="_blank"><button class="btn btn-sm ml-2 text-white" style="background-color: #0288d1;" ngbTooltip="Create Testcase">Create</button></a>
                </div>
                <div class="common-box">
                  <div class="endpoint-list-sec">
                    <div *ngIf="!testcaseList || testcaseList.length === 0">No data found</div>
                    <div *ngFor="let testcase of testcaseList" title="{{testcase.testCaseName}}" class="list">
                      <a [routerLink]="['/testcase', testcase.testCaseId]" target="_blank">
                        <i class="fas fa-link" ngbTooltip="Go to testcase"></i>
                      </a>
                      {{ testcase.testCaseName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>